export default "__VITE_ASSET__BF0W1LPo__"